export { applicationSettings } from './ApplicationSettings';
